<template>
	<div id="app" style="height: 100%">
		<DefaultLayout v-if="getLayout === 'default'">
			<router-view />
		</DefaultLayout>

		<PlainLayout v-if="getLayout === 'plain'">
			<router-view />
		</PlainLayout>

		<ActiveCustomerHandler/>
	</div>
</template>

<script>
import DefaultLayout from '@/layouts/Default';
import PlainLayout from '@/layouts/Plain';
import ActiveCustomerHandler from './components/active-customer-handler';
import { mapActions } from 'vuex';

export default {
  components: {
    DefaultLayout, // ✅ Use correct name here
    PlainLayout,
    ActiveCustomerHandler
  },

  computed: {
    getLayout() {
      return this.$route?.meta?.layout
        ? this.$route.meta.layout.toLowerCase()
        : 'default';
    }
  },

  created() {
    window.addEventListener('resize', this.checkWidth);
    this.checkWidth();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidth);
  },

  methods: {
    ...mapActions('appStore', ['setMobileState']),

    checkWidth() {
      this.setMobileState(window.innerWidth < 1024);
    }
  }
};
</script>

